export enum Label {
  Tournament = "Tournament",
  Player = "Player",
  Game = "Game",
  Standing = "Standing",
}
